<script>
/**
 * Descripción: pag BlogViewComponent
 *
 * @displayName BlogViewComponent
 */

const TheArticles = () =>
  import(
    /* webpackChunkName: "BlogViewComponent" */ '@/components/core/layouts/TheArticles'
  );

const TheBanner = () =>
  import(
    /* webpackChunkName: "BlogViewComponent" */ '@/components/core/forms/TheBanner'
  );

export default {
  name: 'BlogViewComponent',

  components: {
    TheArticles,
    TheBanner
  }
};
</script>

<template>
  <TheArticles>
    <TheBanner />
  </TheArticles>
</template>
